import type { DataDefinition } from '../../../store/dataDefinitionsSlice';

/** 데이터 정의(SAM파일/DB테이블) → 캔버스 데이터 노드의 type/label/config. "워크플로에 추가" 버튼과 목록 드래그 드롭이 공유 */
export function nodeFromDataDefinition(def: DataDefinition, baseConfig: Record<string, any> = {}): { type: 'csvData' | 'rdbData'; label: string; config: Record<string, any> } {
  if (def.type === 'sam') {
    return {
      type: 'csvData', label: def.name,
      config: { ...baseConfig, filepath: def.source.filepath || '', delimiter: def.source.delimiter || ',', hasHeader: def.source.hasHeader ?? true,
        format: (def.source as any).format || 'delimited', encoding: (def.source as any).encoding || 'UTF-8',
        fieldWidths: (def.source as any).fieldWidths || '', fieldNames: (def.source as any).fieldNames || '',
        tableColumns: def.columns.map((c) => ({ name: c.name, dataType: c.dataType, comment: '' })), dataDefinitionId: def.id },
    };
  }
  return {
    type: 'rdbData', label: def.name,
    config: { ...baseConfig, connection: def.source.connection || '', schema: def.source.schema || '', table: def.source.table || '',
      columns: def.columns.map((c) => c.name), tableColumns: def.columns.map((c) => ({ name: c.name, dataType: c.dataType, comment: '' })), dataDefinitionId: def.id },
  };
}
